import styled from 'styled-components'
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const ModalComponent = styled(Modal)``

export const ModalFooterComponent = styled('div')`
  display: flex;
  text-align: center;
  width: 100%;
  padding: 0;
`

export const ButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
  justify-content: center;
  margin: auto;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    flex-direction: row;
  }
`

export const CustomButton = styled(Button)`
  padding: 0 12px;
  width: 100%;
  min-width: 190px;

  :last-child {
    margin-bottom: 30px;
  }

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    max-width: 200px;

    :first-child {
      margin-right: 24px;
    }

    :last-child {
      margin-bottom: 0;
    }
  }
`

export const TitleContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const ModalTitle = styled('div')`
  margin: 0;
  text-align: center;
`
export const ModalSubtitle = styled('p')`
  margin: 0;
  margin-bottom: 16px;
`

export const Spacer = styled.div`
  margin-left: 10px;
`
